// extracted by mini-css-extract-plugin
export default {"box":"styles_box__WHSyV","container":"styles_container__wpvYp","custom-file-upload":"styles_custom-file-upload__s4sf1","help":"styles_help__fUxNh"};